import type { IAutoReviewMissingField } from '@user/store/draftLeads/typings'

import { groupMissingFields } from './groupMissingFields'

/**
 * Missing fields the "Update Required Fields" modal cannot edit: the referral and any key this
 * client does not recognise. They need the full Review flow.
 */
export function getNonEditableMissingFields(
  missing: IAutoReviewMissingField[],
): IAutoReviewMissingField[] {
  return groupMissingFields(missing).flatMap((group) => {
    if (group.kind === 'unknown') return [group.field]
    if (group.kind === 'additional' && group.key === 'referral')
      return [group.field]
    return []
  })
}

/** The missing fields the modal can edit (everything except getNonEditableMissingFields). */
export function getEditableMissingFields(
  missing: IAutoReviewMissingField[],
): IAutoReviewMissingField[] {
  const nonEditable = new Set(getNonEditableMissingFields(missing))
  return missing.filter((field) => !nonEditable.has(field))
}

/** Whether any missing field needs the full Review flow instead of the modal. */
export function hasNonEditableMissingFields(
  missing: IAutoReviewMissingField[],
): boolean {
  return getNonEditableMissingFields(missing).length > 0
}
